import { Group, type ButtonProps } from "@mantine/core";
import { IconPlus, IconTrash, type TablerIcon } from "@tabler/icons-react";
import {
  type MRT_RowData,
  type MRT_RowSelectionState,
  type MRT_TableOptions
} from "mantine-react-table-open";
import { IconButton } from "./components/IconButton/IconButton";
interface MRTTopToolbarCustomActionsOptions<ArrayedTData> {
  create?: {
    text?: string;
    disabled?: boolean;
    onClick?: () => void;
    hide?: boolean;
    variant?: ButtonProps["variant"];
  };
  delete?: {
    text?: string | ((selectedRows: ArrayedTData) => string);
    hide?: boolean;
    icon?: TablerIcon;
    onClick?: (rowSelection: MRT_RowSelectionState) => void;
  };
}

/** Define Mantine-React-Table renderer for top toolbar custom actions */
export function getMRTTopToolbarCustomActionsRenderer<
  TData extends MRT_RowData
>(
  options: MRTTopToolbarCustomActionsOptions<Array<TData>> = {}
): Partial<MRT_TableOptions<TData>> {
  const showCreateButton = !options.create?.hide;
  const showDeleteButton = !options.delete?.hide;

  return {
    enableRowSelection: true,
    positionToolbarAlertBanner: "none",
    renderTopToolbarCustomActions: ({ table }) => (
      <Group gap="xs" justify="flex-end" p={0} w="100%">
        {showCreateButton && (
          <IconButton
            color="primary"
            disabled={
              options.create?.disabled ||
              table.getState().creatingRow !== null ||
              table.getState().editingRow !== null
            }
            icon={IconPlus}
            variant={options.create?.variant || "filled"}
            onClick={() =>
              options.create && options.create.onClick
                ? options.create.onClick()
                : table.setCreatingRow(true)
            }
          >
            {options.create?.text || "Erstellen"}
          </IconButton>
        )}
        {showDeleteButton && (
          <IconButton
            className="mrt-delete-button"
            color="error"
            disabled={Object.values(table.getState().rowSelection).length === 0}
            icon={options.delete?.icon || IconTrash}
            variant="white"
            onClick={() =>
              options.delete?.onClick
                ? options.delete.onClick(table.getState().rowSelection)
                : undefined
            }
          >
            {typeof options.delete?.text === "function"
              ? options.delete.text(
                  table.getSelectedRowModel().rows.map((row) => row.original)
                )
              : options.delete?.text || "Löschen"}
          </IconButton>
        )}
      </Group>
    )
  };
}
